var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-2 mx-2"},[_c('Header',{attrs:{"loading":_vm.loading,"selectPlaceService":_vm.selectPlaceService},on:{"setSelectPlaceService":_vm.setSelectPlaceService}}),_c('timeline-all',{staticClass:"mb-10"}),_c('v-divider',{staticClass:"my-5"}),_c('places')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }